import { useState } from "react";
import { MdClose } from "react-icons/md";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import {
  ActionSection,
  Label,
  ScrollableContent,
  SideCancelBtn,
  SubmitBtn,
} from "./Styles/InputStyles";

const widthClasses = {
  "11/12": "lg:w-11/12 md:w-10/12 w-11/12",
  "8/12": "lg:w-8/12 md:w-6/12 w-11/12",
  "6/12": "lg:w-6/12 md:w-6/12 w-11/12",
  "4/12": "lg:w-4/12 md:w-5/12 w-11/12",
  "3/12": "lg:w-3/12 md:w-4/12 w-11/12",
  "1/3": "lg:w-1/3 md:w-5/12 w-11/12"
};

const SelectFeaturesModal = ({
  isOpen,
  onClose,
  title = "Select Features",
  options = [],
  selectedValue = [],
  onSelect,
  isLoading = false,
  searchPlaceholder = "Search...",
  width,
}) => {
  const [searchText, setSearchText] = useState("");

  if (!isOpen) return null;

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handleSelect = (value) => {
    let updatedValues = [];

    if (selectedValue.includes(value)) {
      updatedValues = selectedValue.filter((item) => item !== value);
    } else {
      updatedValues = [...selectedValue, value];
    }

    onSelect(updatedValues);
  };

  const isSelected = (value) => {
    return selectedValue.includes(value);
  };

  return (
    <Overlay>
      <ModalWrapper $width={width}>
        <Header>
          <h1 className="text-white text-lg font-medium">{title}</h1>
          <button onClick={onClose}>
            <MdClose color="white" size={24} />
          </button>
        </Header>

        <div className="px-4 pt-4 relative">
          <div className="relative">
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="w-full px-2 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
            />
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              {/* <GoSearch className="w-4 h-4 text-gray-400" /> */}
            </div>

            {searchText && (
              <button
                type="button"
                onClick={() => setSearchText("")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-zinc-500"
              >
                <MdClose size={18} />
              </button>
            )}
          </div>
        </div>

        <ScrollableContent className="max-h-[calc(100dvh-140px)]">
          {isLoading ? (
            <div className="flex justify-center py-8">
              <CircularProgress />
            </div>
          ) : filteredOptions.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No options found
            </div>
          ) : (
            filteredOptions.map((option) => (
              <OptionRow
                key={option.value}
                onClick={() => handleSelect(option.value)}
              >
                <Label>{option.label}</Label>

                {isSelected(option.value) ? (
                  <FaRegCheckSquare size={20} className="text-primary-color" />
                ) : (
                  <FaRegSquare size={20} className="text-gray-300" />
                )}
              </OptionRow>
            ))
          )}
        </ScrollableContent>

        <ActionSection>
          <SideCancelBtn
            type="button"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </SideCancelBtn>
          <SubmitBtn onClick={onClose}>Confirm</SubmitBtn>
        </ActionSection>
      </ModalWrapper>
    </Overlay>
  );
};

export default SelectFeaturesModal;

const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`;
const ModalWrapper = tw.div`
  bg-white h-full flex flex-col relative
  ${(props) => widthClasses[props.$width] || "w-11/12"}
`;
// const ModalWrapper = tw.div`bg-white h-full flex flex-col relative ${(props) => (props.$width ? `w-${props.$width}` : "w-11/12")}`;
const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`;
const OptionRow = tw.div`ml-2 flex items-center justify-between p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50`;
const Footer = tw.div`p-4 border-t flex justify-end`;
const DoneBtn = tw.button`bg-primary-color hover:bg-hover-color text-white px-4 py-2 rounded-md shadow-md`;
